import { createAction, props } from '@ngrx/store';

import { GeneralState } from '../app.state';

export const setGeneralData = createAction('[General] Set general data', props<GeneralState>());
